module.exports = __webpack_public_path__ + "img/technology11.c9745f57.png";